module.exports = __webpack_public_path__ + "img/article-2-3.4db410db.jpg";